


















import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions } from "vuex";
import * as a_ecr from "@/store/modules/FitnessStatisticsModule/actions";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
        };
    },
    computed: {
        ...mapState({
            availableSensorModels: (state: RootState): string[] => state.fitnessStatistics.availableSensorModels,
        }),
    },
    watch: {
        selectedItems() {
            this.$emit("input", this.selectedItems);
        },
    },
    methods: {
        ...mapActions([a_ecr.GET_DISTINCT_SENSORS_DATA]),
    },
    async mounted() {
        this.loading = true;
        if (this.availableSensorModels == null || this.availableSensorModels.length == 0) await this[a_ecr.GET_DISTINCT_SENSORS_DATA]();
        this.loading = false;
    },
});
